import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class applicationService extends ApiBaseService {
  constructor(public http: HttpClient) {
    super(http, '/applications');
  }

  checkNameExists(name: string, id?: boolean | number): Observable<any> {
    const tagId = id ? id : null;
    const params = { name, tagId };
    return this.http.get(`${environment.apiUrl}/applications/check`, {
      params,
    });
  }

  submitApplication(body: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/applications/submmitApplications`, body);
  }

  submitApplicationToken(body: any,token:any): Observable<any> {
    const obj = {
      ...body,
      token
    }
    return this.http.post(`${environment.apiUrl}/external/submmitApplications`, obj);
  }

  getApplication(params: any, token: any) {
    if (typeof token === 'string' && token.trim() !== '') {
      return this.http.get<any>(`${environment.apiUrl}/external/portalApplication`, {
        params: params,
      });
    } else {
      return this.http.get<any>(`${environment.apiUrl}/applications/portalApplication`, {
        params: params,
      });
    }
  }

  getApplicationEmbed(params: any): Observable<any> {
    // Fix: Use the correct endpoint path
    return this.http.get(`${environment.apiUrl}/external/applications/embed`, { params });
  }

  /**
   * Submit embedded application
   */
  submitEmbedApplication(data: any): Observable<any> {
    // Fix: Use the correct endpoint path
    return this.http.post(`${environment.apiUrl}/external/applications/embed/submit`, data);
  }
  exportApplicationPdf(applicationId: number): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/applications/export-application/${applicationId}`, {
      responseType: 'blob',
    });
  }
}
